import React, { useState, useEffect, useCallback } from 'react';
import { useGruposStore } from '../../store/GruposStore';
import { Paper, Typography, Box, Stack, Pagination } from '@mui/material';

// Importando os componentes filhos
import FiltrosBusca from '../../components/FiltroBuscaDeMaquinas';
import TabelaGrupos from '../../components/TabelaDeGrupos';
import ModalEdicaoGrupos from '../../components/ModalEdicaoDeGrupos';
import ModalCriacaoDeGrupos from '../../components/ModalCriacaoDeGrupos';
import FiltrosBuscaDeGrupos from '../../components/FiltroDeBuscaDeGrupos'
import ConfirmDeleteModal from '../../components/ModalDeConfirmacao';

export default function SubgruposPage() {

    const {
        pagina_atual,
        ultima_pagina,
        carregando,
        fetchGrupos,
        searchGrupos,
        updateGrupos,
        CreateGrupo,
        deleteGrupo,
        deletingId,
        grupos,
        setFiltroDeBusca,
    } = useGruposStore();

    // Estado local para controlar o modal de edição
    const [modalAberto, setModalAberto] = useState(false);
    const [modalCriacaoAberto, setmodalCriacaoAberto] = useState(false);
    const [grupoSelecionado, setgrupoSelecionado] = useState(null);
    const [ModalConfirmacao, setModalConfirmacao] = useState(false);
    const [msgModalConfirmacao, setMsgModalConfirmacao] = useState('');

    // Busca inicial dos dados quando o componente é montado
    useEffect(() => {
        fetchGrupos();
    }, [fetchGrupos]);

    // Funções de callback otimizadas com useCallback
    const handleBusca = useCallback((filtros) => {
        setFiltroDeBusca(filtros);
        searchGrupos(filtros);
    }, [searchGrupos]);

    const handleLimparBusca = useCallback(() => {
        fetchGrupos(1); // Volta para a primeira página ao limpar
    }, [fetchGrupos]);

    const handleAbrirModal = useCallback((produto) => {
        setgrupoSelecionado(produto);
        setModalAberto(true);
    }, []);

    const handleAbrirModalConfirmacao = useCallback(() => {
        setModalConfirmacao(true)
    }, []);

    const handleFecharModalConfirmacao = useCallback(() => {
        setModalConfirmacao(false)
    }, []);

    const handleFecharModal = useCallback(() => {
        setModalAberto(false);
        setgrupoSelecionado(null);
    }, []);

    const handleFecharModalCriacao = useCallback(() => {
        setmodalCriacaoAberto(false);
    }, [])

    const handleAbrirModalCriacao = useCallback(() => {
        setmodalCriacaoAberto(true);
    }, [])

    const handleSalvarEdicao = useCallback(async (dadosGrupo) => {
        let resposta = await updateGrupos(dadosGrupo);
        if (!resposta) return;
        handleFecharModal();
        setFiltroDeBusca(null);
    },);

    const handleSalvarCriacao = useCallback(async (dadosGrupo) => {

        let resposta = await CreateGrupo(dadosGrupo);

        if (resposta) {
            handleFecharModalCriacao();
            return;
        };

    }, [CreateGrupo, handleFecharModalCriacao]);

    const handleExcluir = useCallback((produto) => {
        handleAbrirModalConfirmacao();
        setMsgModalConfirmacao('Deseja realmente excluir este produto?');
        setgrupoSelecionado(produto);
    }, [deleteGrupo]);

    const handleConfirmarExlusao = useCallback((produto) => {
        handleFecharModalConfirmacao();
        setMsgModalConfirmacao('');
        deleteGrupo(produto);
    }, []);




    const handlePageChange = useCallback((event, page) => {
        fetchGrupos(page);
    }, [fetchGrupos]);

    return (
        <Paper elevation={3} sx={{ p: 3, borderRadius: 3, width: '100%', }}>
            <Typography variant="h5" component="h1" gutterBottom>
                Gerenciamento de Sub grupos
            </Typography>

            <FiltrosBuscaDeGrupos
                onSearch={handleBusca}
                onClear={handleLimparBusca}
                oncreate={handleAbrirModalCriacao}
            />

            <Box sx={{ mt: 4 }}>
                <TabelaGrupos
                    grupos={grupos}
                    onEdit={handleAbrirModal}
                    onDelete={handleExcluir}
                    loadingState={{ carregando, deletingId }}
                />
            </Box>

            <Stack spacing={2} sx={{ mt: 3, alignItems: 'center' }}>
                <Pagination
                    page={pagina_atual}
                    count={ultima_pagina}
                    onChange={handlePageChange}
                    color="primary"
                    shape="rounded"
                    disabled={carregando !== 'idle'}
                />
            </Stack>

            {/* MODAL DE EDIÇÃO */}
            {modalAberto && (
                <ModalEdicaoGrupos
                    open={modalAberto}
                    onClose={handleFecharModal}
                    onSave={handleSalvarEdicao}
                    grupos={grupoSelecionado}
                    isLoading={carregando === 'updating'}
                />
            )}

            {/* MODAL DE CRIACAO */}
            {modalCriacaoAberto && (
                <ModalCriacaoDeGrupos
                    open={modalCriacaoAberto}
                    onSave={handleSalvarCriacao}
                    onClose={handleFecharModalCriacao}
                    isLoading={carregando === 'creating'}

                />
            )}

            {
                ModalConfirmacao && (
                    <ConfirmDeleteModal
                        mensagem={msgModalConfirmacao}
                        open={ModalConfirmacao}
                        onClose={handleFecharModalConfirmacao}
                        titulo={'Atenção'}
                        onConfirm={() => { handleConfirmarExlusao(grupoSelecionado) }}
                    />
                )
            }
        </Paper>
    );
}